import formApiClient from "../../helpers/services/form-api-client";
import { GetFacebookFormResponse } from "../interfaces/api/get-facebook-form";
import { GetFacebookFormsResponse } from "../interfaces/api/get-facebook-forms";
import {
  GetFacebookFormContactResponsesResponse,
  LinkFacebookLeadToContactRequest,
  LinkFacebookLeadToContactResponse,
} from "../interfaces/api/get-facebook-form-contact-response";
import { facebookFormMapper } from "./mapper";

export const facebookFormApiService = {
  getFacebookForms(companyId: string) {
    return formApiClient()
      .get<GetFacebookFormsResponse>(`form/facebook`, { params: { companyId } })
      .then(({ data }) => facebookFormMapper.mapResponseToFacebookForms(data));
  },
  getFacebookForm(companyId: string, formId: string) {
    return formApiClient()
      .get<GetFacebookFormResponse>(`form/facebook/${formId}`, { params: { companyId } })
      .then(({ data }) => facebookFormMapper.mapResponseToFacebookForm(data));
  },
  getFacebookFormResponsesByContact(companyId: string, contactId: string) {
    return formApiClient()
      .get<GetFacebookFormContactResponsesResponse>(
        `form/facebook/responses/contact`,
        { params: { companyId, contactId } }
      )
      .then(({ data }) => data.payload || []);
  },
  linkLeadToContact(
    companyId: string,
    payload: LinkFacebookLeadToContactRequest
  ) {
    return formApiClient()
      .post<LinkFacebookLeadToContactResponse>(
        `form/facebook/leads/link-contact`,
        payload,
        { params: { companyId } }
      )
      .then(({ data }) => data.payload);
  },
};
